var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPending2X(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pending@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Status---Pending",
    transform: "translate(-698.000000, -246.000000)",
    fill: "#F5A623",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(115.000000, 117.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pending",
    transform: "translate(583.000000, 129.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,0 C16.1652338,0 10.5695796,2.31812182 6.44357777,6.44389968 C2.31776454,10.5696775 0,16.1657552 0,22.0001886 C0,27.8346219 2.31776454,33.430511 6.44357777,37.5564775 C10.569391,41.6822553 16.1655167,44 22,44 C27.8344833,44 33.4304204,41.6822553 37.5564222,37.5564775 C41.6822355,33.4306996 44,27.8346219 44,22.0001886 C44,18.1385065 42.9834912,14.3446163 41.052775,10.9998114 C39.121776,7.65557232 36.3442678,4.87818216 33.0000943,2.9471997 C29.6554494,1.01650009 25.8615266,0 21.9996229,0 L22,0 Z M22,39.600792 C17.3320362,39.600792 12.8552865,37.7461814 9.55505079,34.4454083 C6.25424935,31.1450123 4.39981143,26.668301 4.39981143,22.0005657 C4.39981143,17.3328305 6.25424935,12.8559306 9.55505079,9.55572318 C12.8554751,6.25495003 17.3322247,4.400528 22,4.400528 C26.6677753,4.400528 31.1447135,6.25495003 34.4449492,9.55572318 C37.7457507,12.8561192 39.6001886,17.3328305 39.6001886,22.0005657 C39.6001886,25.0899491 38.7869627,28.1251179 37.2418806,30.8004903 C35.6971757,33.4762399 33.4755839,35.6978126 30.7998114,37.2425042 C28.1244161,38.7875731 25.0892213,39.600792 21.9998114,39.600792 L22,39.600792 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8003939,8.74398379 C21.2238645,8.74398379 20.6706293,8.97449931 20.2629824,9.38532732 C19.8553354,9.79578944 19.6264008,10.3525168 19.6264008,10.9329806 L19.6264008,20.9810932 L13.7344808,26.8917476 C13.2744221,27.2882869 12.9996261,27.8603444 12.9759686,28.4697986 C12.9526745,29.0792621 13.1830719,29.6711625 13.6114599,30.1024527 C14.0394939,30.5338085 14.6272697,30.7654217 15.2325439,30.7419667 C15.8378275,30.7185117 16.4060082,30.4414522 16.7997719,29.9782163 L23.3221238,23.4108225 C23.7319511,23.00659 23.9663551,22.4561111 23.974359,21.8785557 L23.974359,10.9325865 C23.974359,10.3520758 23.7454244,9.7953954 23.3377774,9.38493328 C22.9301304,8.97410527 22.3769418,8.74358974 21.8003659,8.74358974 L21.8003939,8.74398379 Z",
    id: "Path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending2X);
export default __webpack_public_path__ + "static/media/Pending@2x.cf5d4dcfb715d7439536010af76250f0.svg";
export { ForwardRef as ReactComponent };